export default __webpack_public_path__ + "media/images/loading-c380c4d3616bd4dbac3e2397104a2413.svg";